var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 22,
    fill: "#256CB5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.459 2c3.396 0 6.545.747 9.362 2.158.414.25.911.415 1.326.664l-1.989 1.744-2.983-3.072-4.97 4.483-2.983-3.238-9.28 8.468 5.965 6.558-2.32 2.075 5.883 6.64-2.32 2.076 8.368 9.38 4.971-4.565 4.309 4.897a23.896 23.896 0 0 1-2.817 1.91C30.832 43.92 27.27 45 23.459 45 11.61 44.917 2 35.288 2 23.5S11.61 2 23.459 2Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.482 22.089 5.137-4.566 4.556 5.064-5.054 4.648-4.64-5.146Zm3.645 8.799 5.137-4.566 4.557 5.147-5.137 4.566-4.557-5.147Zm-7.291-17.515 5.137-4.566 4.557 5.064-5.054 4.648-4.64-5.146Zm9.362-2.491L29.01 7.48l3.48 3.818-3.812 3.487-3.48-3.902Zm6.794 15.856 3.811-3.487 3.48 3.819-3.811 3.486-3.48-3.819Zm3.398 7.72 3.81-3.487 3.397 3.819-3.81 3.486-3.398-3.818Zm1.49-17.765 2.569-2.241 2.32 2.49-2.569 2.324-2.32-2.573Zm-3.23-7.554 2.568-2.324 2.237 2.573-2.486 2.324-2.32-2.573Zm6.545 15.191 2.485-2.324L45 24.579l-2.568 2.241-2.237-2.49Zm-11.434-5.728 3.811-3.403 3.397 3.818-3.811 3.404-3.397-3.819Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg25);
export default __webpack_public_path__ + "static/media/25.907e36844e38c4e227526cf017d02bf0.svg";
export { ForwardRef as ReactComponent };